/**
 * Helper DOM minimi (no framework).
 */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<Omit<HTMLElementTagNameMap[K], 'children' | 'style'>> & {
    class?: string;
    style?: string;
    dataset?: Record<string, string>;
    on?: Partial<Record<keyof HTMLElementEventMap, EventListener>>;
  } = {},
  children: (Node | string | null | undefined)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v === undefined || v === null) continue;
    if (k === 'class') node.className = v as string;
    else if (k === 'style' && typeof v === 'string') node.setAttribute('style', v);
    else if (k === 'dataset') Object.assign(node.dataset, v);
    else if (k === 'on')
      for (const [evt, fn] of Object.entries(v as Record<string, EventListener>)) {
        node.addEventListener(evt, fn);
      }
    else {
      const desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(node), k);
      if (desc && desc.get && !desc.set) {
        // read-only property (e.g. HTMLInputElement.list) — use setAttribute instead
        node.setAttribute(k, String(v));
      } else {
        (node as unknown as Record<string, unknown>)[k] = v;
      }
    }
  }
  for (const c of children) {
    if (c === null || c === undefined) continue;
    node.append(c instanceof Node ? c : document.createTextNode(c));
  }
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function mount(root: HTMLElement, content: Node): void {
  clear(root);
  root.append(content);
}
